import React from 'react'
import Header from '../../component/layout/header'
import { Outlet } from 'react-router'
import useNav from '../../component/custom-hooks/get-nav';

const ConfigLayout = () => {
  const navList = useNav();
  let { configTopHeaderNav, configBottomNav } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={configBottomNav} topTabs={configTopHeaderNav} />
      <Outlet />
    </div>
  )
}

export default ConfigLayout
